<yc-modal
  [modalHeader]="'ACCOUNT:hdrDownloadMyData' | ycI18n: 'Download My Data'"
  [primaryButtonText]="'common:textDownload' | ycI18n: 'Download'"
  [cancelButtonText]="'common:btnCancel' | ycI18n: 'Cancel'"
  (onCancel)="onCancel()"
  (onPrimaryClick)="handlePrimaryClick()"
  [helpLink]="!isManager ? downloadAccountDataHelpLinkApplicant : downloadAccountDataHelpLinkManager">

  <div class="table-wrapper">
    <table tabIndex="0">
      <caption
        class="sr-only">
        <yc-i18n
          key="common:textMyPersonalData"
          defaultValue="My personal data">
        </yc-i18n>
      </caption>
      <tr>
        <th>
          <yc-i18n
            key="common:textFirstName"
            defaultValue="First name">
          </yc-i18n>:
        </th>
        <td>{{ user.firstName }}</td>
      </tr>
      <tr>
        <th>
          <yc-i18n
            key="common:textLastName"
            defaultValue="Last name">
          </yc-i18n>:
        </th>
        <td>{{ user.lastName }}</td>
      </tr>
      <tr>
        <th>
          <yc-i18n
            key="common:textEmail"
            defaultValue="Email">
          </yc-i18n>:
        </th>
        <td>{{ user.email }}</td>
      </tr>
      <tr *ngIf="!isManager && phoneNumber">
        <th>
          <yc-i18n
            key="common:textPhoneNumber"
            defaultValue="Phone number">
          </yc-i18n>:
        </th>
        <td>{{ phoneNumber }}</td>
      </tr>
      <tr *ngIf="isManager && jobTitle">
        <th>
          <yc-i18n *ngIf="isManager && jobTitle"
            key="common:textJobTitle"
            defaultValue="Job title">
          </yc-i18n>:
        </th>
        <td>{{ jobTitle }}</td>
      </tr>
      <tr *ngIf="!isManager && usersAddress">
        <th>
          <yc-i18n *ngIf="!isManager && usersAddress"
            key="common:textAddress"
            defaultValue="Address">
          </yc-i18n>:
        </th>
        <td>
          <div [innerHtml]="usersAddress"></div>
        </td>
      </tr>
    </table>
  </div>
</yc-modal>